import React from 'react'
import { useNavigate } from 'react-router-dom'
import Header2 from '../Layouts/Header2'
import Footer from '../Layouts/Footer'
import Image from '../Assets/Images/Values.png'
import { FaArrowLeft } from "react-icons/fa";

const OurValues = () => {

    const navigate = useNavigate();


  return (
    <>

            <div className="max-w-6xl mx-auto mt-[70px] flex items-center gap-4">
                <span 
                    className="cursor-pointer text-[#70962f] text-xl hover:text-[#5a7a26]"
                    onClick={() => navigate(-1)}
                    title="Go back"
                >
                    <FaArrowLeft />
                </span>
                <h2 className="text-4xl font-bold text-[#70962f]">Our Values at SolarMore Solution </h2>
            </div>

            <img src={Image} className="w-[1000px] h-full object-cover mx-auto py-6" alt="Our Offering " />

            <Footer />
    </>
  )
}

export default OurValues